import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Input, Button, Spin, Card, Col, Row } from "antd";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../UserPermissionsContext";
import { all_routes } from "../../../router/all_routes";
import { Toast } from "react-bootstrap";

type Student = {
  SCS_Number: string;
  name: string;
  admission_status_name: string;
  state_name: string;
  zone_name: string;
  branch_name: string;
  orientation_name: string;
  student_class_name: string;
  is_wizklub_paid_last_year: boolean;
  is_wizklub_paid: boolean;
  academic_year:string;
};

const PhoneNumberToStudent = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const [students, setStudents] = useState<Student[]>([]);
  const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  useEffect(() => {
    if (!checkPermission("get_students_by_phone_number", "student")) {
      navigate(routes.crmLandingPage);
    }
  }, [userPermissions]);

  useEffect(() => {
      setTimeout(() => {
        setShowSolidDangerToast(false);
        setToastMessage("")
      }, 3000);
    }, [toastMessage]);

  const handleSearch = async () => {
    // if (phoneNumber.length !== 10 || isNaN(Number(phoneNumber))) {
    //   setToastMessage("Please enter a valid 10-digit phone number.");
    //   setShowSolidDangerToast(true);
    //   return;
    // }
    setIsLoading(true);
    try {
      const response = await fetch(
        `${webApi}/students/get_students_by_mobile_number/?mobile_number=${phoneNumber}`, options
      );
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
        setToastMessage(errorData.message);
        setShowSolidDangerToast(true);
        // throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setStudents(data);
    } catch (error) {
      console.error("Error fetching student details:", error);
      // alert("Failed to fetch student details. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Page Header */}
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">Phone Number and SCS Number To Student</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Phone Number and  SCS Number To Student
                </li>
              </ol>
            </nav>
          </div>
        </div>
        {/* Search Input */}
        <div className="mb-4">
          <Input
            placeholder="Enter 10-digit phone number or SCS Number"
            maxLength={10}
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            style={{ width: "300px", marginRight: "10px" }}
          />
          <Button type="primary" onClick={handleSearch}>
            Search
          </Button>
        </div>
        {/* Loader or Cards */}
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100px",
            }}
          >
            <Spin />
          </div>
        ) : (
          <Row gutter={[16, 16]}>
            {students.map((student) => (
              <Col
                key={student.SCS_Number}
                xs={24} // For mobile devices: single card per row
                sm={12} // For tablets: two cards per row
                lg={8} // For laptops and larger screens: three cards per row
              >
                <Card
                  style={{
                    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                    borderRadius: "10px",
                  }}
                >
                  <p>
                    <strong>SCS Number:</strong>
                    <span style={{ marginLeft: "8px" }}>{student.SCS_Number}</span>
                  </p>
                  <p>
                    <strong>Name:</strong>
                    <span style={{ marginLeft: "8px" }}>{student.name}</span>
                  </p>
                  <p>
                    <strong>Admission Status:</strong>
                    <span style={{ marginLeft: "8px" }}>{student.admission_status_name}</span>
                  </p>
                  <p>
                    <strong>State:</strong>
                    <span style={{ marginLeft: "8px" }}>{student.state_name}</span>
                  </p>
                  <p>
                    <strong>Zone:</strong>
                    <span style={{ marginLeft: "8px" }}>{student.zone_name}</span>
                  </p>
                  <p>
                    <strong>Branch:</strong>
                    <span style={{ marginLeft: "8px" }}>{student.branch_name}</span>
                  </p>
                  <p>
                    <strong>Orientation:</strong>
                    <span style={{ marginLeft: "8px" }}>{student.orientation_name}</span>
                  </p>
                  <p>
                    <strong>Class:</strong>
                    <span style={{ marginLeft: "8px" }}>{student.student_class_name}</span>
                  </p>
                  <p>
                    <strong>Paid Last Year:</strong>
                    <span style={{ marginLeft: "8px" }}>
                      {student.is_wizklub_paid_last_year ? "Yes" : "No"}
                    </span>
                  </p>
                  <p>
                    <strong>Paid This Year:</strong>
                    <span style={{ marginLeft: "8px" }}>
                      {student.is_wizklub_paid ? "Yes" : "No"}
                    </span>
                  </p>
                  <p>
                    <strong>Academic Year:</strong>
                    <span style={{ marginLeft: "8px" }}>
                      {student.academic_year}
                    </span>
                  </p>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </div>
      <Toast
        show={showSolidDangerToast}
        onClose={handleSolidDangerToastClose}
        id="solidDangerToast"
        className="colored-toast bg-danger text-fixed-white"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        style={{
          position: "fixed",
          top: "20px",
          right: "20px",
          zIndex: 1050,
        }}
      >
        <Toast.Body>{toastMessage}</Toast.Body>
      </Toast>
    </div>
  );
};

export default PhoneNumberToStudent;
